import AddDisciplineModal from "./AddDisciplineModal";

export default AddDisciplineModal;